"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _cmsCmsGenerateReport = _interopRequireDefault(require("@/api/cmsCmsGenerateReport"));

var _vuex = require("vuex");

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {};
var _default = {
  name: 'SubByTwo',
  components: {
    pagination: _Pagination.default,
    crudOperation: _CRUD.default,
    udOperation: _UD.default
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  dicts: [],
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '报表',
      url: 'api/CmsGenerateReport/getReportData',
      idField: 'rowId',
      sort: [null],
      crudMethod: _objectSpread({}, _cmsCmsGenerateReport.default)
    });
  },
  created: function created() {
    this.crud.optShow.add = false;
    this.crud.optShow.edit = false;
    this.crud.optShow.del = false;
    this.crud.optShow.download = false;
  },
  data: function data() {
    return {
      innerVisible: false,
      outerVisible: false,
      title1: "测试",
      isFirst: false,
      rowId: '',
      queryTypes: {},
      queryType: {},
      titleData: [],
      outerData: [],
      innerData: [],
      reportData: [],
      penetrateList: [],
      cols: [{
        prop: 'contractNumber',
        label: '合同号',
        width: 150
      }],
      cities: [{
        prop: 'rowId',
        label: '报表id',
        width: 150
      }, {
        prop: 'reportName',
        label: '报表名称',
        width: 150
      }, {
        prop: 'sqlStatement',
        label: 'sql语句',
        width: 150
      }, {
        prop: 'isStoredProcedure',
        label: '是否为存储过程',
        width: 150
      }, {
        prop: 'createTime',
        label: '创建时间',
        width: 150,
        query: 'createTime',
        type: 'date'
      }],
      permission: {}
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'user', 'filesUploadApi'])),
  methods: (0, _defineProperty2.default)({
    init: function init(rowId) {
      var _this = this;

      console.log("传进来的rowId");
      console.log(rowId);
      this.innerVisible = true;
      this.query.rowId = rowId;
      this.rowId = rowId;

      _cmsCmsGenerateReport.default.get(rowId).then(function (res) {
        _this.titleData = JSON.parse(res.content[0].header);
        console.log(res);
      });

      this.isFirst = true;
      this.crud.toQuery();
    },
    resetQuery: function resetQuery() {
      this.queryType = {};
      this.queryUsers = {};
      this.crud.resetQuery();
    }
  }, _crud.default.HOOK.beforeRefresh, function () {
    return this.isFirst;
  })
};
exports.default = _default;